import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/About';
import ProjectsSection from '../components/ProjectSection';
import ContactBanner from '../components/ContactBanner';
import TestimonialsSection from '../components/BadgesSection';

export default function Home() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <ProjectsSection />
      <TestimonialsSection />
      <ContactBanner />
    </div>
  );
}
